import type { AxiosResponse, InternalAxiosRequestConfig } from './types'
// import type { AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import { ElMessage } from 'element-plus'
import qs from 'qs'
import { SUCCESS_CODE, TRANSFORM_REQUEST_DATA } from '@/constants'
import { useLocaleStore } from '@/store/modules/locale'
import { useUserStoreWithOut } from '@/store/modules/user'

import { objToFormData } from '@/utils'
import { useI18n } from '@/hooks/web/useI18n'

const defaultRequestInterceptors = (config: InternalAxiosRequestConfig) => {
  // 设置语言
  const localeStore = useLocaleStore()
  config.headers['local-language'] = localeStore.getCurrentLocale.lang === 'en' ? 'en-US' : 'zh-CN'
  if (
    config.method === 'post' &&
    config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
  ) {
    config.data = qs.stringify(config.data)
  } else if (
    TRANSFORM_REQUEST_DATA &&
    config.method === 'post' &&
    config.headers['Content-Type'] === 'multipart/form-data'
  ) {
    config.data = objToFormData(config.data)
  }
  if (config.method === 'get' && config.params) {
    let url = config.url as string
    url += '?'
    const keys = Object.keys(config.params)
    for (const key of keys) {
      if (config.params[key] !== void 0 && config.params[key] !== null) {
        url += `${key}=${encodeURIComponent(config.params[key])}&`
      }
    }
    url = url.substring(0, url.length - 1)
    config.params = {}
    config.url = url
  }
  return config
}

const defaultResponseInterceptors = (response: AxiosResponse) => {
  const userStore = useUserStoreWithOut()
  const { t } = useI18n()
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  if (response?.config?.responseType === 'blob') {
    // 如果是文件流，直接过
    return response
  } else if (response.data.code === SUCCESS_CODE) {
    return response.data
  } else {
    if (response?.data?.code === 401) {
      if (!user.token) {
        // 多个窗口登陆时store独立，需要直接取localStorage
        ElMessage.closeAll()
        response.data.msg && ElMessage.error(response.data.msg)
        userStore.logout()
      } else if (+userStore.getUserInfo?.expireTime > new Date().getTime()) {
        userStore.setAccountRrror({
          error: true,
          errorTips: t('login.landingInOther')
        })
      } else {
        userStore.setAccountRrror({
          error: true,
          errorTips: t('login.landingOvertime')
        })
      }
    } else if (response?.data?.code === 69080011) {
      userStore.setAccountRrror({
        error: true,
        errorTips: response.data.msg
      })
      ElMessage.closeAll()
      response.data.msg && ElMessage.error(response.data.msg)
    } else if (response?.data?.code === 69080018) {
      userStore.setAccountRrror({
        error: true,
        errorTips: response.data.msg
      })
      ElMessage.closeAll()
      response.data.msg && ElMessage.error(response.data.msg)
    } else if (response?.data?.code === 69080201) {
      // 多个窗口登陆时store独立，需要直接取localStorage
      ElMessage.closeAll()
      response.data.msg && ElMessage.error(response.data.msg)
      userStore.logout()
    } else if (!response?.config?.hideMsg) {
      ElMessage.closeAll()
      response.data.msg && ElMessage.error(response.data.msg)
    }

    return Promise.reject(response)
  }
}

export { defaultResponseInterceptors, defaultRequestInterceptors }
